<template>
  <div class="office-info-wrap">
    <div
        ref="box"
        class="office-info-text"
        :class="{
          expanded: isExpanded,
          collapsed: !isExpanded,
          'with-toggle': showToggle
        }"
        :style="collapsedStyle"
        v-html="html"
    />

    <button
        v-if="showToggle"
        type="button"
        class="office-info-toggle"
        @click="toggle"
        aria-label="Показать/скрыть"
    >
      <span class="toggle-inner">
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            fill="currentColor"
            class="chevron"
            viewBox="0 0 16 16"
            :class="{ up: isExpanded }"
        >
          <path
              fill-rule="evenodd"
              d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
          />
        </svg>

        <span class="toggle-text">
          {{ isExpanded ? 'Свернуть' : 'Показать весь текст' }}
        </span>
      </span>
    </button>
  </div>
</template>

<script>
export default {
  name: "OfficeInfoText",
  props: {
    html: { type: String, default: "" },        // сюда отдаём уже отформатированный html (с <br>)
    lines: { type: Number, default: 3.5 },      // сколько строк показывать по умолчанию
  },
  data() {
    return {
      isExpanded: false,
      showToggle: false,
      lineHeightPx: 0,
    };
  },
  computed: {
    collapsedStyle() {
      if (this.isExpanded) return {};
      if (!this.lineHeightPx) return {};
      return {
        maxHeight: `${this.lineHeightPx * this.lines}px`,
      };
    },
  },
  mounted() {
    this.recalc();
    window.addEventListener("resize", this.recalc, { passive: true });
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.recalc);
  },
  watch: {
    html() {
      this.isExpanded = false;
      this.$nextTick(() => this.recalc());
    },
  },
  methods: {
    toggle() {
      this.isExpanded = !this.isExpanded;
    },
    recalc() {
      const el = this.$refs.box;
      if (!el) return;

      const cs = window.getComputedStyle(el);
      const lh = parseFloat(cs.lineHeight);

      // если line-height = "normal" (редко, но бывает)
      this.lineHeightPx = Number.isFinite(lh) ? lh : 18;

      const collapsedH = this.lineHeightPx * this.lines;

      // scrollHeight сравниваем после того, как применился max-height
      // поэтому на время измерения раскрываем, меряем, потом возвращаем
      const wasExpanded = this.isExpanded;
      this.isExpanded = true;

      this.$nextTick(() => {
        const fullH = el.scrollHeight;

        this.showToggle = fullH > collapsedH + 1; // небольшой запас
        if (!this.showToggle) this.isExpanded = true; // текста мало — пусть будет по размеру текста
        else this.isExpanded = wasExpanded;           // иначе вернём состояние
      });
    },
  },
};
</script>

<style scoped>
.office-info-wrap {
  position: relative;
  display: inline-block;
  width: auto;
}

/* сам текст */
.office-info-text {
  background: #ffd9a64a;
  padding: 0.5rem 1rem 0.5rem;
  font-size: 0.9rem;
  border-radius: 0.5rem;
  border: 1px solid #dbbf5173;

  white-space: normal;
  word-break: break-word;
}

/* добавляем место под кнопку ТОЛЬКО если она есть */
.office-info-text.with-toggle {
  padding-bottom: 1.4rem;
  margin-bottom: 1.4rem;
}

.office-info-text.collapsed {
  overflow: hidden;
  position: relative;
}

.office-info-text.with-toggle.collapsed {
  padding-bottom: 1.6rem;
}

/* fade снизу */
.office-info-text.collapsed::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 1.8em;
  background: linear-gradient(to bottom, rgba(255, 217, 166, 0), rgb(255 244 230));
  pointer-events: none;
}

.office-info-toggle {
  position: absolute;
  left: 50%;
  bottom: calc(1.4rem - 16px);
  transform: translateX(-50%);

  background: #ffd9a6;
  border-radius: 0.6rem;
  padding: 2px 10px;

  display: inline-flex;
  align-items: center;
  gap: 6px;

  cursor: pointer;
  border: 1px solid #ffffff;
  box-shadow: 1px -2px 5px rgb(0 0 0 / 28%);
}

.office-info-toggle:hover {
  background: #ffcf8a;
}

.toggle-inner {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.toggle-text {
  font-size: 0.75rem;
  white-space: nowrap;
  color: #704a00;
}

.chevron {
  transition: transform 0.2s ease;
  color: #704a00;
}

.chevron.up {
  transform: rotate(180deg);
}
</style>